export default __webpack_public_path__ + "static/media/test.d5ee5206.MP4";